/**
 * Run non-critical work after the browser is idle.
 * The timeout is only the fallback when requestIdleCallback never fires.
 */
export function scheduleIdleWork(fn, { timeout = 1500 } = {}) {
    if (typeof window === 'undefined') {
        fn();
        return;
    }

    const run = () => {
        try {
            fn();
        } catch (err) {
            if (typeof console !== 'undefined' && console.error) {
                console.error('[scheduleIdleWork]', err);
            }
        }
    };

    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(run, { timeout });
        return;
    }

    setTimeout(run, 1);
}
